import { getTestIds } from 'seagull/utils/TestIds';
import { ASSIGNABLE_CONTACT_ROLES } from '~/types/api/contacts/assignable-contact-role';
export const changeContactRoleModalTextsPath = 'pages.clientDetail.summary.contacts.changeRoleModal';
export const ROLE_FIELD_NAME = 'role';
export const GetChangeContactRoleModalTID = (parentTestId)=>getTestIds(parentTestId);
export const assignableRoleOf = (contact)=>{
    const role = contact.role();
    if (role == null) return '';
    return ASSIGNABLE_CONTACT_ROLES.includes(role) ? role : '';
};
